// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2uV4i","label":"Radio_label__2GnPa","checkMark":"Radio_checkMark__3k16g","disabled":"Radio_disabled__3NP7a"};